import api from './api';

export interface SamsaraPlace { id: string; name: string; address: string; latitude?: number | null; longitude?: number | null }
export interface MappingLocation {
  id: number; lname: string; ladd?: string; ladd2?: string; lcity?: string; lstate?: string;
  lzip?: string; coordinates?: string; samsara_loc_id?: string | null; deleted?: string;
}
export interface LinkChoice { location_id: number; samsara_loc_id: string }
export interface LinkResult { location_id: number; samsara_loc_id: string | null; status: 'saved' | 'already_linked' | 'conflict' | 'unavailable' }

export async function loadMappingLocations(): Promise<MappingLocation[]> {
  const { data } = await api.get('/geofences/list', { params: { deleted: 'N' } });
  return (data.data as MappingLocation[]).map(row => ({ ...row, id: Number(row.id) }));
}
export async function loadSamsaraPlaces(): Promise<SamsaraPlace[]> {
  const { data } = await api.get('/locations/samsara-places', { timeout: 120000 });
  return data.data;
}
export async function saveLocationLinks(links: LinkChoice[]): Promise<LinkResult[]> {
  const { data } = await api.post('/locations/samsara-links', { links }, { timeout: 120000 });
  return data.results;
}
